const CheckIcon = ({ fill = '#157A08', width = '13', height = '13' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="list/check">
      <mask
        id="mask0_8324_11850"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="13"
        height="13"
      >
        <rect
          id="Bounding box"
          x="0.84375"
          y="0.5"
          width="12"
          height="12"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_8324_11850)">
        <path
          id="icon"
          d="M5.6188 9.50005L2.7688 6.65005L3.4813 5.93755L5.6188 8.07505L10.2063 3.48755L10.9188 4.20005L5.6188 9.50005Z"
          fill={fill}
        />
      </g>
    </g>
  </svg>
)
export default CheckIcon
